import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {RiMapPinTimeFill, RiStopCircleFill} from 'react-icons/ri'
import {NullAsDefault} from 'views/Shared'
import {renderIf, renderIfElse} from '../../../Shared'
import {Avatar} from "antd";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {GoDotFill} from "react-icons/go";
import useTranslate from "../../../../modules/local/useTranslate";
import {PiArrowFatLineRightFill} from "react-icons/pi";
import dayjs from "dayjs";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const renderCourseClassTimetable =
    ({detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {teacher} = item ?? {}
            const {user, prefix_title, contact_phone, contact_email} = teacher ?? {}

            return (
                <Translate key={index}>
                    {(t) => (
                        <div
                            className="w-full flex items-center gap-2 border border-color-50 rounded-lg relative p-2 hover:shadow-items">
                            {renderIf(
                                user,
                                <Avatar
                                    src={user?.avatar}
                                    className="flex flex-center background-100"
                                />
                            )}
                            <div className="flex flex-1 flex-col gap-1">
                  <span className="flex items-baseline flex-1 gap-1 font-bold text-base text-color-000">
                      {renderIf(
                          prefix_title,
                          <span className="font-medium text-sm text-color-100 italic">{prefix_title}.</span>
                      )}
                      {getTitle(teacher)}
                  </span>
                                {renderIf(
                                    detail,
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                        <ItemInformation label="phone" value={contact_phone}/>
                                        <ItemInformation label="email" value={contact_email}/>
                                    </div>
                                )}
                                {renderActions(item)}
                            </div>
                            {_.isFunction(renderContextMenu) && (
                                <div
                                    style={{top: 2, right: 2}}
                                    className="absolute p-1">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }

export const renderCourseClassTeacherAssignment = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {course_class, teacher, subject, from_date, to_date, phase_nbr, phase_title, timetable_details = [], location_address, notes, is_holiday} = item ?? {}

    function getNextLesson(timetables) {
        // Lấy thời gian hiện tại
        const currentDate = dayjs();
        // Lọc các sự kiện có ngày trong tương lai
        const futureDays = timetables.filter(day => dayjs(day.start_time).isAfter(currentDate));
        // Gán ngày tương lai gần nhất vào biến
        let nextLesson = null;
        // Nếu có sự kiện trong tương lai, tìm ngày gần nhất
        if (futureDays.length > 0) {
            nextLesson = futureDays.reduce((nearest, day) => {
                return dayjs(day.start_time).isBefore(dayjs(nearest.start_time)) ? day : nearest;
            }).start_time; // Lấy ra chỉ thuộc tính "date"
        } else {
            nextLesson = false
        }
        return nextLesson; // Trả về ngày gần nhất
    }

    let one_day = formatDate(from_date, 'DD/MM/YYYY') === formatDate(to_date, 'DD/MM/YYYY')

    let is_finished = false

    if (one_day) {
        is_finished = dayjs(from_date).isBefore(dayjs())
    } else {
        is_finished = getNextLesson(timetable_details) === false
    }

    const TitleLesson = ({day}) => {
        const t = useTranslate()
        return (
            <span className="space-x-1 text-xs italic leading-snug">
                <span
                    className="text-color-500 whitespace-no-wrap">{`${t(one_day ? 'lesson at' : 'the next lesson')} : `}</span>
                {renderIfElse(
                    one_day,
                    <span className="font-bold text-blue-600">
                        {formatDate(item?.from_time, "HH:mm:ss", "HH:mm")}
                    </span>,
                    <span className="font-bold text-blue-600">
                        {`${_.capitalize(formatDate(day, 'dddd'))}, ${formatDate(day, "DD/MM/YYYY")} `}
                        {` - ${dayjs(item?.from_time, "HH:mm:ss").format("HH:mm")}`}
                    </span>
                )}
                {renderIf(
                    location_address,
                    <span className="mx-1 text-color-500 whitespace-no-wrap">{t('in')}</span>
                )}
                {renderIf(
                    location_address,
                    <span className="font-semibold text-color-100">{location_address}</span>
                )}
            </span>
        )
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div className={classNames(
                    "p-3 flex flex-col gap-1 border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative",
                    is_finished && 'opacity-60'
                )}>
                    <div className="flex flex-col gap-x-1">
                        <div className={classNames(
                            "mb-3 pb-2 border-b border-color-100 flex items-center gap-1 leading-tight mr-6",
                            is_finished && 'line-through'
                        )}>
                            {renderIfElse(
                                is_holiday === 1,
                                <RiStopCircleFill size={13} className="text-primary-500"/>,
                                <RiMapPinTimeFill size={13}
                                                  className={is_finished ? 'text-color-500' : 'text-green-500'}/>
                            )}
                            {renderIfElse(
                                one_day,
                                <ItemInformation
                                    primary={true}
                                    colon={false}
                                    label="date"
                                    value={formatDate(from_date, 'DD/MM/YYYY')}
                                    className="text-sm italic"
                                />,
                                <DoubleValueItem
                                    primary={true}
                                    colon={false}
                                    labelFirst="from date"
                                    valueFirst={formatDate(from_date, 'DD/MM/YYYY')}
                                    labelSecond={to_date ? 'to date' : ''}
                                    valueSecond={formatDate(to_date, 'DD/MM/YYYY')}
                                    className="text-sm italic"
                                />
                            )}
                            {renderIf(
                                phase_nbr !== 0 && phase_title !== null,
                                <span className="space-x-1 text-xs text-color-500 italic">
                                    {'( '}
                                    <span className="text-color-300">
                                        {`${t('phase')} ${phase_nbr} : `}
                                    </span>
                                    {renderIf(
                                        phase_title,
                                        <span className="font-bold text-color-100 flex-1">
                                            {renderIf(phase_title, phase_title)}
                                        </span>
                                    )}
                                    {' )'}
                                </span>
                            )}
                        </div>
                        {renderIfElse(
                            is_holiday === 1,
                            <div className="ml-3 mt-1 flex flex-col">
                                <div className="flex items-center gap-3">
                                    <PiArrowFatLineRightFill size={11} className="text-primary-300"/>
                                    <span className="font-medium text-xs text-primary-400 italic tracking-widest">
                                        {t('holiday')}
                                    </span>
                                </div>
                                {renderIf(
                                    notes,
                                    <div className="flex items-start gap-1 text-xs italic">
                                    <span className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                        <GoDotFill size={10} className="text-color-500"/>
                                        {`${t('note')} : `}
                                    </span>
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                        {notes}
                                    </span>
                                    </div>
                                )}
                            </div>,
                            <div style={{marginLeft: 2, marginTop: 2}} className="flex flex-col gap-1">
                                <div className="space-x-1 leading-snug">
                                    {renderIfElse(
                                        is_finished,
                                        <PiArrowFatLineRightFill size={11} className="text-primary-600"/>,
                                        <GoDotFill size={10} className="text-color-400"/>
                                    )}
                                    {renderIfElse(
                                        is_finished,
                                        <span
                                            className="font-bold text-xs text-primary-600 italic">{t('finished')}</span>,
                                        <TitleLesson day={getNextLesson(timetable_details)}/>
                                    )}
                                </div>
                                <ItemInformation
                                    showIcon={true}
                                    label="classes"
                                    value={getTitle(course_class)}
                                    className="text-xs italic"
                                />
                                <ItemInformation
                                    showIcon={true}
                                    label="teacher"
                                    value={`${teacher?.prefix_title || ''} ${getTitle(teacher)}`}
                                    className="text-xs italic"
                                />
                                <ItemInformation
                                    showIcon={true}
                                    label="subjects"
                                    value={getTitle(subject)}
                                    className="text-xs italic"
                                />
                                {renderIf(
                                    notes,
                                    <div className="flex items-start gap-1 text-xs italic">
                                    <span className="flex items-center gap-1 text-color-500 whitespace-no-wrap">
                                        <GoDotFill size={10} className="text-color-500"/>
                                        {`${t('note')} : `}
                                    </span>
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                        {notes}
                                    </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="absolute top-5 right-0 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}
